// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Documents_wrap__31b6l","title":"Documents_title__3e_-r"};